import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/full-screen-loading-overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlarmsProvider"] */ "/app/components/providers/alarms-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AtomsProvider"] */ "/app/components/providers/atoms-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReportsProvider"] */ "/app/components/providers/reports-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignalRProvider"] */ "/app/components/providers/signal-r-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeManager"] */ "/app/components/providers/theme-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/toast/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastsProvider"] */ "/app/components/toast/toasts-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/components/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/.pnpm/next-auth@5.0.0-beta.19_next@14.2.35_@babel+core@7.25.2_@opentelemetry+api@1.9.0_react-dom@18_gcfdontsyet6x7bdrh6bd6g2zi/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.25.2_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
